<script lang="ts">
    import cn from 'classnames';
    import { configService } from '$lib/services';

    import type { UserCurrent } from '@api/types';
    import sc from '@components/common/common.module.css';
    import { globalStore } from '@components/stores';
    import { isOperator, userStore } from '@components/user/store';
    import { landingPages, URLS } from '@shared/routing';
    import { IdentityStatus, UserStatus } from '@shared/types';

    import { Logo } from './components/logo';
    import { SettingsDropdown } from './components/settings-dropdown';
    import { UnauthButtons } from './components/unauth-buttons';

    import s from './header.module.css';

    import { page } from '$app/stores';

    export let isDesktop: boolean;

    let user: UserCurrent | undefined;
    $: user = $userStore.user;
    let isNotOperator: boolean;
    $: isNotOperator =
        Boolean(user && !$isOperator && user.gender && user.isEmailVerified) &&
        user?.identityStatus !== IdentityStatus.Pending;
    let isVerified: boolean;
    $: isVerified = Boolean(user?.isEmailVerified && user?.identityStatus === IdentityStatus.Verified);
    $: isLandingPage = landingPages().includes($page.url.pathname);
    let isMenuShow: boolean;
    $: isMenuShow = Boolean(user
        && $page.url.pathname !== URLS.roomCall()
        && $page.url.pathname !== URLS.roomSearch()
        && (!$page.route?.id || !URLS.isRoom($page.route.id))
        && (!$page.route?.id || !URLS.isMessage($page.route.id) || isDesktop)
        && ($page.url.pathname !== URLS.roomSettings() || isDesktop));
    let geoBlocked: string | null;
    $: geoBlocked = $globalStore.geoBlocked;
</script>

<header class={cn(s.root, { [s.desktop]: isDesktop, [s.fixed]: isLandingPage })}>
    <div class={cn(isLandingPage ? sc.mainContainer : s.container)}>
        <Logo link={user ? URLS.roomStart() : URLS.index()} flag={geoBlocked}/>

        {#if isMenuShow}
            {#await import('@components/layout/menu') then { Menu }}
                <Menu />
            {/await}
        {/if}

        {#if !configService.get('isUnsupportedDevice')}
            <nav class={cn(s.buttonsWrapper, { [s.authorized]: user })}>
                {#if user && isNotOperator && user.status !== UserStatus.Blocked}
                    {#await import('./components/buy-button') then { BuyButton }}
                        {#if user}
                            <BuyButton {isDesktop} {user} />
                        {/if}
                    {/await}
                {/if}

                {#if !geoBlocked}
                    <SettingsDropdown/>
                {/if}
                {#if $isOperator && isVerified}
                    {#await import('./components/balance') then { Balance }}
                        <Balance {isDesktop} />
                    {/await}
                {/if}

                {#if !user && !geoBlocked}
                    <UnauthButtons />
                {:else}
                    {#await import('./components/profile-dropdown') then { ProfileDropdown } }
                        <ProfileDropdown {isMenuShow}/>
                    {/await}
                {/if}
            </nav>
        {/if}
    </div>
</header>
